// extracted by mini-css-extract-plugin
export default {"root":"footer_root__H7w6S"};